import { serverMessage } from '../error/server-message'

// The grid's block (TableAgInfinite's cacheBlockSize is 200), so one block is
// one page; the admin reads allow up to 200 (a session's records up to 500).
export const PAGE = 200

const compact = filters => Object.fromEntries(Object.entries(filters || {}).filter(([, value]) => value !== '' && value !== null && value !== undefined))

// The datasource function (getRows) of a TableAgInfinite whose server pages
// by cursor (`next`) while the grid pages by row index: each block start
// remembers the cursor that reaches it. A server may cut a page short (the ai
// service's admin reads keep a page under a byte budget) and still answer a
// `next`, so a short page is not the last: a block follows `next` until it
// holds its rows or `next` is null, which is the only end. (The grid's blocks
// are PAGE rows apart, so the block is filled here, asking each time only for
// what is missing, and the next block's cursor is the last page's `next`.)
// fetchPage(params) -> { items, next }, `next` null on the last page;
// toRow(item) -> a row. A failure goes to setError(message, err) and ends the
// list where it is. A `next` that is the cursor just sent ends the list too,
// so a server that stops advancing cannot keep this asking. Used by the AI
// tools lists and the staff API keys list.
export const cursorPager = (fetchPage, toRow, filters, setError, failedText) => {
  const cursors = { 0: '' }
  const query = compact(filters)
  return async (start, end) => {
    const cursor = cursors[start]
    if (cursor === undefined) return { data: [], count: start }
    try {
      const limit = Math.min(end - start, PAGE)
      const items = []
      let from = cursor
      let next = null
      do {
        const asked = limit - items.length
        const page = await fetchPage(from ? { ...query, cursor: from, limit: asked } : { ...query, limit: asked })
        items.push(...((page && page.items) || []).map(toRow))
        next = (page && page.next) || null
        if (next === from) next = null
        from = next
      } while (next && items.length < limit)
      if (next) {
        cursors[start + items.length] = next
        return { data: items, count: -1 }
      }
      return { data: items, count: start + items.length }
    } catch (err) {
      setError(serverMessage(err, failedText), err)
      return { data: [], count: start }
    }
  }
}
